import { combineReducers } from "redux";

import programhighlight from "../features/admin/courses/programhighlight/Slice";
import eligibilityrequirement from "../features/admin/courses/eligibilityrequirement/Slice";
import careerrequirement from "../features/admin/courses/careerrequirement/Slice";
import requirementdocuments from "../features/admin/courses/requirementdocuments/Slice";
import universities from "../features/admin/courses/university/Slice";
import course from "../features/admin/courses/course/Slice";
import accomodations from "../features/admin/courses/accomodation/Slice";
import studyprogram from "../features/admin/courses/studyprogram/Slice";

const courses = combineReducers({
  programhighlight: programhighlight,
  eligibilityrequirement: eligibilityrequirement,
  careerrequirement: careerrequirement,
  requirementdocuments: requirementdocuments,
  universities: universities,
  course: course,
  accomodations: accomodations,
  studyprogram: studyprogram,
});

export default courses;
